import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { launch0Stats } from '@/mocks/launch';

export default function DataBoard() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="数据看板"
            title="0# 核心首发数据"
            subtitle="这些数据来自九畴云市首发项目清单，属于项目规划与首发目标。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-4">
            {launch0Stats.map((s) => (
              <div
                key={s.label}
                className="p-6 rounded-lg bg-foreground-950 border border-foreground-800"
              >
                <div className="font-heading font-bold text-3xl md:text-4xl text-accent-400">
                  {s.value}
                </div>
                <div className="mt-2 text-sm text-foreground-400 leading-snug">{s.label}</div>
              </div>
            ))}
          </div>
          <p className="mt-6 text-xs text-foreground-500 max-w-3xl leading-relaxed">
            注：以上数据来自九畴云市首发项目清单，属于项目规划与首发目标，实际以项目运营数据为准。
          </p>
        </Reveal>
      </div>
    </section>
  );
}